import { Stack, TablePagination } from '@mui/material';
import React from 'react';

interface CustomTablePaginationProps {
  count: number;
  currentPage: number;
  rowsPerPage?: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => void;
}

const StackPagination: React.FC<CustomTablePaginationProps> = ({
  count,
  currentPage,
  onPageChange,
  rowsPerPage = 25,
  ...paginationProps
}) => {
  return (
    <Stack
      style={{
        display: 'inline-block',
        margin: '10px 10px 10px 0px',
        borderRadius: '6px',
        border: '1px solid #D6D6D6',
        background: '#FFF',
        boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.04)',
        padding: '1px', // Adjust padding as needed
      }}
    >
      <TablePagination
        component='div'
        count={count}
        page={currentPage}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[]}
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
        {...paginationProps}
      />
    </Stack>
  );
};

export default StackPagination;